import { render, staticRenderFns } from "./DashboardPiutangCustomerSummary.vue?vue&type=template&id=989412f2&"
import script from "./DashboardPiutangCustomerSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardPiutangCustomerSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports